module.exports = __webpack_public_path__ + "static/media/oi-colibri.ab444488.mp3";